const routes = {
  myProjects: "my-projects",
  projects: "/projects/:tab",
  createProject: "create-project/*",
  projectDetails: "/project/:id/:tab",
  projectDetails_v1: "/Projects/details/:id",
  faq: "/faq",
  faqArticle: "/faq/:id",
  createFaqArticle: "/faq-create",
  selfOnboarding: "self-onboarding/:projectId/:userId",
  requests: "/requests/:tab",
  editProfile: "/edit-profile",

  admin: {
    billing: "/admin/billing",
    userSearch: "/admin/user-search",
    opcos: "/admin/opcos",
    tools: "/admin/tools",
    packages: "/admin/packages",
    packageEdit: "/admin/packages/:id/edit",
    packageHistory: "/admin/packages/:id/history",
    banners: "/admin/banners",
    packageAccess: "/admin/packages/:id/access",
    jiraWorkflows: "/admin/jira-workflows",
    reports: "/admin/reports",
    reportDetail: "/admin/reports/:id",
    operations: "/admin/operations",
    operationsFigmaCleanup: "/admin/operations/figma-cleanup",
    operationsUserSearch: "/admin/operations/user-search",
    operationsToolSearch: "/admin/operations/tool-search",
    operationsToolsUsersSync: "/admin/operations/tools-users-sync",
    operationsBanners: "/admin/operations/banners",
    operationsJiraWorkflows: "/admin/operations/jira-workflows",
    operationsDetail: "/admin/operations/:id"
  }
};

export default routes;
